<template>
  <div class="TopNav">
    <div class="screen">
      <div class="screen-width">
        <div class="Nav-title" @click="getHome">{{ $t('title') }}</div>
        <div class="search-box">
          <input
            type="text"
            :placeholder="$t('home.placeholder')"
            v-model="searchText"
            @keydown.enter="goSearch()"
            @focus="handlefocus"
          />
          <div class="search-btn" @click="goSearch">
            {{ $t('home.search') }}
          </div>
        </div>
        <div class="right">
          <div class="userbox">
            <img src="" alt="" />
            <div class="textbox">
              <span style="color: #1890ff" @click="getregister()">
                {{ Login ? userName : $t('login.register') }}
              </span>
              <div class="split-s">|</div>
              <span @click="getLogin()">
                {{ Login ? $t('login.exit') : $t('login.login') }}
              </span>
            </div>
          </div>
          <div class="Ranking" @click="setLang">
            <img src="" alt="" />
            <div class="textbox">{{ $t('home.lang') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken, getSession, removeToken, removeSession } from '@/utils/auth';
import { getUserInfo } from '@/request/api/login/login';
export default {
  name: 'TopNav',
  props: '',
  data() {
    return {
      userName: 'user',
      Login: false,
      topLeft: [
        {
          ge: true,
          icon: true,
          text: '手机版',
        },
        {
          ge: false,
          icon: false,
          text: '商家入驻',
        },
      ],
      topRight: [
        {
          ge: true,
          icon: true,
          text: '切换买家',
        },
        {
          ge: true,
          icon: true,
          text: '咚咚',
        },
        {
          ge: true,
          icon: false,
          text: '商家后台',
        },
        {
          ge: true,
          icon: false,
          text: '客户服务',
        },
        {
          ge: true,
          icon: false,
          text: '网站导航',
        },
      ],
      searchText: '',
    };
  },
  components: {},
  created() {
    console.log('不懂吗');
    this.Islogin();
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.getgoods();
      }, 200);
    });
  },
  methods: {
    handlefocus() {},
    getgoods() {
      // console.log('sss', this.$route.query);
      this.searchText = this.$route.query.keyword;
    },
    getHome() {
      if (this.$route.path != '/') {
        this.$router.push('/');
      }
    },
    goSearch() {
      // if (this.$route.path != '/search') {
      //   // this.$router.push('/search');
      //   this.$router.push({
      //     path: '/search',
      //     query: {
      //       keyword: this.searchText,
      //     },
      //   });
      // }
      this.$router.push({
        path: '/search',
        query: {
          keyword: this.searchText,
        },
      });
      setTimeout(() => {
        location.reload();
      }, 200);
    },
    setLang() {
      if (!localStorage.getItem('lang')) {
        localStorage.setItem('lang', 'en_US');
        location.reload();
        return;
      }
      var langs = localStorage.getItem('lang');
      if (langs == 'en_US') {
        localStorage.setItem('lang', 'zh_CN');
        location.reload(); //重新加载
      } else if (langs == 'zh_CN') {
        localStorage.setItem('lang', 'en_US');
        location.reload();
      }
    },
    Islogin() {
      // var tokedata = {
      //   Authorization: getToken(),
      //   updateSession: getSession(),
      // };
      getUserInfo().then((res) => {
        var data = res.data;
        console.log(data);
        if (data.code == 0) {
          this.Login = true;
          this.userName = data.data.user.username;
          console.log(data.data.user.username);
        } else {
          this.Login = false;
        }
      });
    },
    getregister() {
      if (!this.Login) {
        if (this.$route.path != '/register') {
          this.$router.push('/register');
        }
      } else {
      }
    },
    getLogin() {
      if (!this.Login) {
        if (this.$route.path != '/login') {
          this.$router.push('/login');
        }
      } else {
        this.Login = false;
        removeToken();
        removeSession();
        this.$toast.success('Successful exit!', {
          position: 'top-right',
          timeout: 3000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          closeButton: 'button',
          icon: true,
          rtl: false,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.TopNav {
  // background: #fff;
  background: rgb(249, 249, 249);
  min-width: 1200px;
  font-size: 16px;

  .top {
    height: 30px;
    line-height: 30px;
    border-bottom: 1px solid #eee;
    color: #868686;
    min-width: 1200px;
    .top-box {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .split {
        color: #efefef;
        padding: 0 10px;
      }
      .topLeft {
        display: flex;
      }
      .topRight {
        display: flex;
      }
      .wrap {
        display: flex;
      }
    }
  }
  .screen {
    height: 72px;
    padding: 15px 5px;
    min-width: 1200px;
    line-height: 31px;

    .screen-width {
      display: flex;
      justify-content: space-between;
      width: 1200px;
      margin: 0 auto;
      .Nav-title {
        font-size: 38px;
        margin-right: 80px;
        line-height: 50px;
        cursor: pointer;
      }
      .search-box {
        display: flex;
        border-radius: 24px;
        // overflow: hidden;
        input {
          outline: 0 none;
          text-decoration: none;
          box-sizing: border-box;
          width: 509px;
          height: 50px;
          // border: 2px solid #f60;
          border: 2px solid #ddd;
          border-right: none;
          font-size: 14px;
          color: #444;
          line-height: 50px;
          padding-left: 5px;
          border-radius: 20px 0px 0px 20px;
        }
        .search-btn {
          box-sizing: border-box;
          width: 90px;
          display: block;
          float: left;
          background-color: #f60;
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 14px;
          font-weight: 700;
          color: #fff;
          cursor: pointer;
          border-radius: 0px 20px 20px 0px;
        }
      }
      .right {
        display: flex;
        margin-left: 50px;
        line-height: 40px;
        .userbox {
          display: flex;

          .textbox {
            display: flex;

            span {
              padding: 0px 10px;
              cursor: pointer;
            }
            .split-s {
              color: #dfdfdf;
            }
          }
        }
        .Ranking {
          display: flex;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
